import React from 'react';
import { IPRIVATE_TIME_ICON_PROPS } from './props';
import { getTheme } from '@fluentui/react';
import * as ReactDOMServer from 'react-dom/server';

export const FlexTimeIcon: React.FunctionComponent<IPRIVATE_TIME_ICON_PROPS> = (props) => {
  const theme = getTheme();
  const { style } = props;
  const iconHeight = style?.height ?? style?.fontSize;
  const primaryColor = style?.color ?? theme.palette.neutralPrimary;
  const indicatorColor = props.indicatorColor ?? primaryColor;
  
  return (
    <i style={style}>
      <svg style={{ width: '100%', height: iconHeight }} role='img' viewBox="364.034 302.593 119.749 95.211" version="1.1" xmlns="http://www.w3.org/2000/svg" >
        {!!props.title && <title>{props.title}</title>}
        <g fill={primaryColor} >
          <path d="M 414.444 336.442
                    A 38.454 38.454, 0, 0, 1, 465.458 326.586
                    L 471.726 319.266
                    L 480.849 327.106
                    L 474.56 334.365
                    A 38.454 38.454, 0, 1, 1, 414.444 382.2585
                    L 421.075 382.259
                    A 33.363 33.363, 0, 1, 0, 421.075 336.442
                    Z" />
          <path d="M 448.836 365.68
                    A 7.236 7.236, 0, 1, 1, 452.137 361.804
                    L 468.418 375.667
                    A 28.272 28.272, 0, 0, 1, 465.118 379.543
                    Z" />
          <polyline points="442.563,320.996 442.563,310.363 437.372,310.363 437.372,307.684 453.288,307.684 453.288,310.363 448.097,310.363
                            448.097,320.996 453.187,321.708 453.187,315.454 458.378,315.454 458.378,302.593 432.281,302.593 432.281,315.454
                            437.472,315.454 437.472,321.708 442.563,320.996 "/>
        </g>
        <g fill={indicatorColor}>
          <path d="M 457.648 359.81
                    A 12.327 12.327, 0, 0, 0, 445.33 347.024
                    L 445.33 331.078
                    A 28.272 28.272, 0, 0, 1, 471.006 371.185
                    Z" />
        </g>
        <g fill={indicatorColor}>
          <path d="M 364.034 349.758
                    A 20.39 20.39, 0, 0, 1, 390.287 344.42
                    L 398.211 348.638
                    A 14.44 14.44, 0, 0, 0, 415.176 346.13
                    L 421.075 340.265
                    L 421.075 347.444
                    A 19.531 19.531, 0, 0, 1, 395.82 353.132
                    L 387.895 348.915
                    A 15.299 15.299, 0, 0, 0, 370.945 350.641
                    L 364.034 356.37
                    Z" />
          <path d="M 364.034 362.485
                    A 20.39 20.39, 0, 0, 1, 390.287 357.147
                    L 398.211 361.365
                    A 14.44 14.44, 0, 0, 0, 415.176 358.857
                    L 421.075 352.992
                    L 421.075 360.171
                    A 19.531 19.531, 0, 0, 1, 395.82 365.859
                    L 387.895 361.642
                    A 15.299 15.299, 0, 0, 0, 370.945 363.368
                    L 364.034 369.097
                    Z" />
          <path d="M 364.034 375.211
                    A 20.39 20.39, 0, 0, 1, 390.287 369.873
                    L 398.211 374.091
                    A 14.44 14.44, 0, 0, 0, 415.176 371.583
                    L 421.075 365.718
                    L 421.075 372.897
                    A 19.531 19.531, 0, 0, 1, 395.82 378.585
                    L 387.895 374.368
                    A 15.299 15.299, 0, 0, 0, 370.945 376.094
                    L 364.034 381.823
                    Z" />
        </g>
      </svg>
    </i>
  );
};

export const getFlexTimeIconHtml = (props: IPRIVATE_TIME_ICON_PROPS) => {
  const html = ReactDOMServer.renderToString((<FlexTimeIcon {...props} />));
  return html;
};
